import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import {
  QaiGlyphComponent,
  QaiIconComponent,
  QaiInnerWrapComponent,
  QaiButtonComponent,
  QaiBadgeComponent,
} from '@qai/ui';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ButtonComponent } from '../../../components/shared/button/button.component';
import { TooltipComponent } from '../../../components/shared/tooltip/tooltip.component';
import { CapitalizePipe } from '../../../pipes/capitalize.pipe';
import { PipesModule } from '../../../pipes/pipes.module';
import { SharedComponentsModule } from 'src/app/components/shared-components.module';

import { AssignmentComponent } from './assignment.component';
import { CallDetailsModalComponent } from './call-details-modal/call-details-modal.component';
import { PreviousResultsButtonComponent } from './previous-results-button/previous-results-button';
import { PreviousResultsModalComponent } from './previous-results-modal/previous-results-modal.component';
import { TranslocoRootModule } from 'src/app/transloco-root.module';
import { NoCacheSrcDirective } from 'src/app/directives/no-cache-src.directive';

@NgModule({
  declarations: [
    AssignmentComponent,
    CallDetailsModalComponent,
    PreviousResultsModalComponent,
  ],
  imports: [
    ButtonComponent,
    CapitalizePipe,
    CommonModule,
    MatTooltipModule,
    PipesModule,
    PreviousResultsButtonComponent,
    QaiGlyphComponent,
    QaiIconComponent,
    QaiInnerWrapComponent,
    QaiButtonComponent,
    QaiBadgeComponent,
    RouterLink,
    SharedComponentsModule,
    TooltipComponent,
    TranslocoRootModule,
    NoCacheSrcDirective,
  ],
  exports: [
    AssignmentComponent,
    CallDetailsModalComponent,
    PreviousResultsModalComponent,
  ],
})
export class AssignmentModule {}
